import api from '@/modules/api'
import { mutationNames } from '@/store/storeKey'

export default {
  state: {
    selectedTemplateId: 0,
    ChangeTemplateId: 0,
    selectedTemplateCategoryId: 0,
    AppCategory: [],
    AppTemplate: [],
    DefaultTemplate: {
      'EN': '00000000-0002-0001-0000-000000000000',
      'DE': '00000000-0001-0001-0000-000000000000',
      'SubscriptionLevel_Id': 1
    }
  },
  getters: {
    ChangeTemplateId (state) {
      return state.ChangeTemplateId
    },
    selectedTemplateId (state) {
      return state.selectedTemplateId
    },
    selectedTemplateCategoryId (state) {
      return state.selectedTemplateCategoryId
    },
    AppCategory (state) {
      return state.AppCategory
    },
    AppTemplate (state) {
      return state.AppTemplate
    },
    getTemplateByCategoryId: state => Id => {
      return state.AppTemplate.filter(template => template.TemplateCategory === Id)
    },
    getTemplateBySubscriptionId: state => Id => {
      return state.AppTemplate.filter(template => template.Subscription_Id === Id)
    },
    getTemplateByTemplateName: state => TemplateName => {
      return state.AppTemplate.filter(template => template.TemplateName === TemplateName)
    },
    DefaultTemplate (state) {
      return state.DefaultTemplate
    }
  },
  mutations: {
    [mutationNames.SET_SYSTEM_APP_TEMPALTE_CATEGORY] (state, payload) {
      state.AppCategory = payload
    },
    [mutationNames.SET_SYSTEM_APP_TEMPALTE] (state, payload) {
      state.AppTemplate = payload
    },
    setselectedTemplateCategoryId (state, payload) { state.selectedTemplateCategoryId = payload },
    setTemplateId (state, payload) { state.selectedTemplateId = payload },
    setChangeTemplateId (state, payload) { state.ChangeTemplateId = payload }
  },
  actions: {
    async populateCreateAppData ({ dispatch }) {
      await dispatch('getSystemAppTemplateCategory')
      await dispatch('getSystemAppTemplate')
    },
    async getSystemAppTemplateCategory ({ commit }) {
      let response = await api.system.getAppTemplatesCategories(localStorage.getItem('language') ? localStorage.getItem('language').toUpperCase() : 'de')
      commit(mutationNames.SET_SYSTEM_APP_TEMPALTE_CATEGORY, response)
    },
    async getSystemAppTemplate ({ commit }) {
      let response = await api.system.getAppTemplatesApps(localStorage.getItem('language') ? localStorage.getItem('language').toUpperCase() : 'de')
      commit(mutationNames.SET_SYSTEM_APP_TEMPALTE, response)
    },
    async createApp ({ dispatch, commit, rootGetters }, payload) {
      let response = await api.subscription.createApp(payload)
      if (response.isValid && response.IsUserCreated && !response.ErrorMessage) { // when New User created.
        await dispatch('saveToken', { Token: response.Message, Username: payload.Email })
        await dispatch('populateSubscriptions')
        dispatch('setActiveSubscriptionId', response.Subscription_Id)
        let payloaduser = {}
        payloaduser.CoachmarksCompletedTemplateSelection = true
        payloaduser.Id = rootGetters.user.Id
        await api.user.updateClientAddress(payloaduser)
        rootGetters.user.CoachmarksCompletedTemplateSelection = true
        await dispatch('setUser', rootGetters.user)
      } else if (response.isValid && response.IsUserCreated === false && !response.ErrorMessage) { // when user already login
        await dispatch('populateSubscriptions')
        dispatch('setActiveSubscriptionId', response.Subscription_Id)
      }
      return response
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/createApp.js